import * as URI from 'urijs';
import * as Autolinker from 'autolinker';
import { MediaType, MediaDocument } from '../../media-document.model';
import { ICONOCLAST_URL } from '../content-document-adapter.config';

export class ContentDocumentBlogAdapter {
    static toContentDocument(document: any): MediaDocument {
        let contentDocument = new MediaDocument(document);

        contentDocument.documentId = document.documentId;
        // contentDocument.authors = document.authors; // TODO: not sure why but we don't display blog authors, need to follow up with product on this
        contentDocument.date = document.date;
        contentDocument.dupDocs = [];
        contentDocument.isHosted = document.isHosted;
        contentDocument.dupDocsCount = document.dupDocsCount;
        contentDocument.dupDocsIdsRemaining = document.remainingDupDocsIds;
        contentDocument.ingress = document.ingress || document.body;
        contentDocument.keywords = document.keywords || document.tagContextKeywords;
        contentDocument.matchSentences = [document.matchSentence || document.tagContextMatchSentence];
        contentDocument.mediaImageUrl = (document.images && document.images[0]) ? document.images[0].link : '';
        contentDocument.mediaType = MediaType.Blog;
        contentDocument.mediaTypeIcon = document.mediaTypeIcon || contentDocument.mediaType;
        contentDocument.provider = document.provider;
        contentDocument.sentiment = document.isSentimentModified ? document.originalSentiment : document.sentiment;
        contentDocument.sentimentOverride = document.isSentimentModified ? document.sentiment : '';
        contentDocument.sourceAvatarImgUrl = document.sourceUrl ? `${ICONOCLAST_URL}/favicon?size=48&url=${new URI(document.sourceUrl).origin()}` : '';
        contentDocument.sourceAvatarLinkUrl = document.url;
        contentDocument.sourceCountryCode = document.country || document.countryCode;
        contentDocument.sourceName = document.authors[0].name || 'Unknown';
        contentDocument.sourceNameUrl = document.redirectUrl || document.url;
        contentDocument.tags = document.tags;
        contentDocument.title = document.title;
        contentDocument.titleUrl = document.redirectUrl || document.url;
        contentDocument.language = document.language;

        // TODO: not sure if we need this, might be same as sourceUrl
        contentDocument.url = document.redirectUrl || document.url || document.sourceUrl;

        // TODO: not sure if we should bake in support for these but putting them in for now
        contentDocument.socialEchoDocumentUrl = document.url;
        contentDocument.reachCount = document.reach;
        contentDocument.potentialReach = document.potentialReach;

        return contentDocument;
    }
}



// WEBPACK FOOTER //
// ./src/lib/components/content-documents/media-document/adapter/adapters/content-document-blog.adapter.ts